import React from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import '../index.css';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { resourceApi } from '../utils/fetchUtil';
import CircularProgress from 'material-ui/CircularProgress';
import Chip from 'material-ui/Chip';
import TabStrip from '../Components/TabStrip';
import HeaderSmall from '../Components/Header/HeaderSmall';
import Accumulator from '../Components/Accumulator';
import Benefits from '../Components/Benefits';
import NonMedicalBenefits from '../Components/NonMedicalBenefits';
import ChatWithCareGuideFooter from '../Components/ChatWithCareGuideFooter';
import Lightbox from 'react-image-lightbox';
import { loadClientUserPlans } from '../actions/memberActions';



const styles = {

    mediumIcon: {
        color: '#666',
        width: 40,
        height: 40,
    },
    medium: {
        width: 40,
        height: 40,
        float: 'right',
        padding: 0
    }
}


class MyBenefits extends React.Component {

    constructor() {
        super();
        this.state = {
            alertMessage: "",
            open: false,
            benefits: [],
            photoIndex: 0,
            isOpen: false,
            activeIndex: 0,
            benefitTypes : [],
            plansByBenefitType : [],
        }
    }

    componentDidMount() {
        if(!Array.isArray(this.props.plans)){
            this.props.loadClientUserPlans()
            .then(res => this.filterPlansByType())
        } else {
            this.filterPlansByType()
        }
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    tabChange = (index) => {
        this.setState({ activeIndex: index })
    }

    filterPlansByType = () => {

        const plans = this.props.plans

        let benefitTypes = [];
        let plansByBenefitType = [];
        if(Array.isArray(plans) && plans.length !== 0){
            benefitTypes = [...new Set(plans.map(p => p.BenefitTypeID))]
            plansByBenefitType = benefitTypes.map(bt => {
                return (
                    plans.filter(p => p.BenefitTypeID == bt)
                )
            } )
        }
        this.setState({plansByBenefitType:plansByBenefitType, benefitTypes:benefitTypes})
    }

    render() {
        const benefitTypes = this.state.benefitTypes;
        const plansByBenefitType = this.state.plansByBenefitType;        
        const footerText = "For additional information or questions about your benefits, please chat with your care guide."

        const actions = [
            <FlatButton
                label="Close"
                primary={true}
                onClick={this.handleClose}
            />
        ];

        return (
            <div>
                {!this.props.plans && (
                    <div className="centered">
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <CircularProgress color="#999999" />
                    </div>
                )}
                {this.props.plans && (
                    <div>
                        <HeaderSmall title="My Benefits" />
                        <div style={{ width: "90vw", margin: "0 auto" }}>
                            {Array.isArray(plansByBenefitType) && plansByBenefitType.map((pbt, index) => (
                                <div key={index} style={{ display: 'inline-block', float: "left", width: 85, textAlign: 'center', marginTop:15, marginBottom:15 }}>
                                    {index === this.state.activeIndex ?
                                        <Chip
                                            style={{ margin: '0 auto', textTransform: 'uppercase' }}
                                            onClick={() => { this.tabChange(index) }}
                                        >
                                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{pbt[0].BenefitPlanType}</span>
                                        </Chip>
                                        :
                                        <div style={{ marginTop: 5 }}>
                                            <span onClick={() => { this.tabChange(index) }} style={{ fontSize: '14px', textTransform: 'uppercase', fontWeight: 'normal', color: '#999999' }}>{pbt[0].BenefitPlanType}</span>
                                        </div>
                                    }
                                </div>
                            ))}
                        </div>
                        < div style={{ padding: '0', margin: '0', clear: "both" }}></div>
                        <div style={{ width: "90vw", margin: "0 auto" }}>
                            {benefitTypes.length > 0 && benefitTypes[this.state.activeIndex] === 1 && plansByBenefitType[this.state.activeIndex].map((plan, i) => (
                                <div style={{ width: "100%" }} key={i}>
                                    {plan.Accumulators.length < 1 && plan.Networks.map((net, index) => (
                                        <Paper key={index} style={{ width: "90vw", margin: "0 auto" }}>
                                            <div key={index} className="container" >
                                                <Benefits net={net} plan={plan} />
                                            </div>
                                        </Paper>
                                    ))}
                                    {plan.Accumulators && plan.Accumulators.length > 0 && (
                                        <Paper style={{ width: "90vw", margin: "0 auto" }}>
                                            <div className="container" >
                                                <Accumulator member={this.props.member} plan={plan} />
                                            </div>
                                        </Paper>
                                    )}
                                    <br />
                                </div>
                            ))}
                            {benefitTypes.length > 0 && benefitTypes[this.state.activeIndex] != 1 && plansByBenefitType[this.state.activeIndex].map((plan, i) => (
                                <div key={i} style={{ width: "100%" }}>
                                    {plan.Networks.map((net, index) => (
                                        <Paper key={index} style={{ width: "90vw", margin: "0 auto" }}>
                                            <div className="container" >
                                                <NonMedicalBenefits net={net} plan={plan} />
                                            </div>
                                        </Paper>
                                    ))}
                                </div>
                            ))}
                        </div>
                        

                                {this.props.member.IsTwoWayMessagingActive && (
                                    <div>
                                        {plansByBenefitType.length === 0 && (
                                            <div className={'ios-extra-top-spacing'}></div>
                                        )}
                                        <div style={{ width: '85vw', paddingBottom: '8px', margin: '0 auto' }}>
                                            <ChatWithCareGuideFooter Text={footerText} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <TabStrip activeTab={0} />
                    </div >
                );
    }
};

//export default MyBenefits;

const mapDispatchToProps = (dispatch) => {
    return {
            loadClientUserPlans: () => {
             return dispatch(loadClientUserPlans())
        }
    }
}


const mapStateToProps = (state) => ({
    isFetching: state.thisApp.environment.isFetching,
    member: state.thisApp.auth.member,
    plans: state.thisApp.member.plans
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyBenefits)



// WEBPACK FOOTER //
// ./src/Pages/MyBenefits.js